// extracted by mini-css-extract-plugin
export default {"video":"Videos_video__HYGm2","video-container":"Videos_video-container__VVy1w"};